import React from "react";
import axios from "axios";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

componentDidCatch(error, info) {
  console.log("ERROR BOUNDARY FIRED!!!");  // <-- DEBUG

  setTimeout(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/log/react-error`, {
      error: error.toString(),
      info,
      url: window.location.href,
    }).catch(() => {});
  }, 0);
}


  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
